const fileName = (elem, event) => {
  const { target: input } = event;
  const error = input.getAttribute('data-error-message');
  const name = input.getAttribute('data-filename');

  if (error) { // Error has precedence over value and file name
    input.setAttribute('data-error-message', '');
    elem.innerText = error;
  } else if (input.value) { // Value on file selected
    const [filename] = input.value.split('\\').slice(-1);
    elem.innerText = filename;
  } else if (name) { // Value from preload model
    elem.innerText = name;
  }
};

const configureFileInput = (fileInput) => {
  // Create file button
  const fileButtonElem = document.createElement('button');
  fileButtonElem.className = 'btn';
  fileButtonElem.innerText = 'upload file';
  fileButtonElem.type = 'button';
  fileButtonElem.onclick = () => { fileInput.click(); };
  // Create file name
  const fileNameElem = document.createElement('span');
  fileNameElem.className = 'file__name';
  // Create file wrapper
  const fileWrapperElem = document.createElement('div');
  fileWrapperElem.className = 'eep-input__file';
  fileWrapperElem.appendChild(fileButtonElem);
  fileWrapperElem.appendChild(fileNameElem);
  // Hide original input
  fileInput.parentNode.appendChild(fileWrapperElem);
  fileInput.style.display = 'none';
  // Add change listener for file name
  fileInput.addEventListener('change', fileName.bind(null, fileNameElem));
  // Initialize
  fileName(fileNameElem, { target: fileInput });
};

export default () => {
  const fileInputs = document.querySelectorAll('.js-eep-input-file');

  fileInputs.forEach((fileInput) => {
    configureFileInput(fileInput);
  });

  return () => {
    fileInputs.forEach((fileInput) => {
      const fileNameElem = fileInput.parentNode.querySelector('.eep-input__file').querySelector('span');
      fileInput.removeEventListener('change', fileName.bind(null, fileNameElem));
    });
  };
};
